/* import __COLOCATED_TEMPLATE__ from './project-completion-actions.hbs'; */
import { equal } from '@ember/object/computed';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { PROJECT_COMPLETION__SUB_VIEWS } from 'sh-www/constants/routes/project-completion';

/**
 * This will handle all the action logic for the project completion flow for buyers and sellers.
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-project-completion-actions'],

  /**
   * Register services
   */
  state: service('states/routes/project-completion'),
  stateManager: service('state-managers/routes/project-completion'),
  media: service(),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  isUpdatingTestBillingRecord: false,

  /** @param {Function} handleSubmit Handler function for form submission. */
  onSubmit: () => {},

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}
   */
  _isCancelDisabled: computed(function() {
    return false;
  }),

  /**
   * @type {Boolean}
   */
  _isContinueDisabled: computed('state.isSubmittingProjectInformationForm', function() {
    return this.get('state.isSubmittingProjectInformationForm');
  }),

  /**
   * @type {Boolean}
   */
  _isSubmitDisabled: computed(
    'state.isSubmittingProjectInformationForm',
    'isUpdatingTestBillingRecord',
    'state.isAdvancePayment',
    'state.testBillingRecord.amount',
    function() {
      if (this.get('state.isAdvancePayment')
        && (!this.get('state.testBillingRecord') || this.get('state.testBillingRecord.amount') <= 0)
      ) {
        // Not ready to submit advance
        return true;
      }

      return this.get('state.isSubmittingProjectInformationForm') || this.get('isUpdatingTestBillingRecord');
    }
  ),

  /**
   * @type {Boolean}
   */
  _isShowAdjustAdvanceButton: equal('state.subView', PROJECT_COMPLETION__SUB_VIEWS),

  /**
   * @type {Boolean}
   */
  _isShowSecondaryButton: computed(
    'state.subView',
    'state.isAdvancePayment',
    'state.isApprovingAdvance',
    'state.isEditingAdvance',
    function() {
      if (this.get('state.isAdvancePayment')) {
        return this.get('state.isApprovingAdvance') || this.get('state.isEditingAdvance');
      } else {
        return this.get('state.subView') === PROJECT_COMPLETION__SUB_VIEWS.PUBLIC_FEEDBACK;
      }
    }),

  _secondaryButtonLabel: computed(
    'state.subView',
    'state.isAdvancePayment',
    'state.isApprovingAdvance',
    'state.isEditingAdvance',
    function () {
      if (this.get('state.isAdvancePayment')) {
        if (this.get('state.isEditingAdvance')) {
          return 'Cancel adjustment';
        } else if (this.get('state.isApprovingAdvance')) {
          if (this.get('state.isBuyerViewing')) {
            return 'Adjust advance';
          }
          return 'Request adjustment';
        }
      } else {
        return 'Back';
      }
    }),

  _submitButtonLabel: computed(
    'state.isAdvancePayment',
    'state.isBuyerViewing',
    'state.isApprovingAdvance',
    'state.isEditingAdvance',
    function() {
      if (this.get('state.isAdvancePayment')) {
        if (this.get('state.isApprovingAdvance') && !this.get('state.isEditingAdvance')) {
          return 'Accept advance';
        } else {
          // Advance workflow
          if (this.get('state.isBuyerViewing')) {
            return 'Submit advance';
          } else {
            return 'Request advance';
          }
        }
      } else {
        // Project completion workflow
        if (this.get('state.isBuyerViewing')) {
          return 'Continue';
        } else {
          return 'Mark project complete';
        }
      }
    }),

  actions: {
    /**
     *
     */
    onSecondary() {
      if (this.get('state.isAdvancePayment')) {
        // Either way, reset the test billable to our advance billable
        this.get('stateManager').setTestBillingRecord(this.get('state.approvingAdvanceBillingRecord'));

        if (this.get('state.isEditingAdvance')) {
          this.set('state.isEditingAdvance', false);
        } else if (this.get('state.isApprovingAdvance')) {
          // If we are approving, fetch a test billable based on our current one to switch the owner to the viewer
          this.get('stateManager.updateTestBillingRecord').perform();
          this.set('state.isEditingAdvance', true);
        }
      } else {
        this.get('stateManager').handleBackClicked();
      }
    },

    onSubmit() {
      this.get('onSubmit')();
    },
  }
});
